import { createSlice } from '@reduxjs/toolkit';
import { LOGOUT } from '../../../utils/constants';
import { getUserInfoBuilder } from './builder';

const INIT_STATE = {
  user: null,
  pending: {},
};

export const userSlice = createSlice({
  name: 'user',
  initialState: INIT_STATE,
  reducers: {},
  extraReducers: builder => {
    getUserInfoBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const selectUser = state => state.userInfo.user;
export const selectUserActionsPending = state => state.userInfo.pending;

export default userSlice.reducer;
